import React from 'react';

const Ongshogrohon = () => {
    return (
        <div>

<div class="d-flex align-items-center justify-content-center text-dark p-5">
{/* <img className="img-fluid w-75 mt-5" src="https://cdn.swapps.com/uploads/2019/01/how-to-implement-a-basic-facebook-messenger-chatbot.jpg" alt="Loading.....Please Wait" /> */}
<h2>
A <div className="text-info"> chatbot </div>of UTSABD Facebook Page <br/>  will be here ,for  interactive connection <br/> to our Dear User ..... <br/> .....The Dev Guy is working on it,Thank you</h2>
</div>        </div>
    );
};

export default Ongshogrohon;